import Head from 'next/head'

export const ThemeStyle = ({ siteTheme }) => {
  return (
    <Head>
      <style id="theme" type="text/css" dangerouslySetInnerHTML={{ __html: siteTheme }} />
    </Head>
  )
}
